/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', function() {
  // Functie om tekst nodes te vinden en te vervangen
  const findAndReplaceText = function(element) {
    // Doorloop alle child nodes
    if (element.childNodes && element.childNodes.length > 0) {
      element.childNodes.forEach(node => {
        // Als het een tekstnode is en "QUANTITY_" bevat
        if (node.nodeType === 3 && node.textContent.includes('QUANTITY_')) {
          // Vervang alleen het "QUANTITY_XXX" gedeelte, behoud de rest
          const newText = node.textContent.replace(/QUANTITY_[^(]*/g, 'Bulkkorting ');
          node.textContent = newText;
        } else if (node.nodeType === 1) {
          // Als het een element is, doorzoek recursief
          findAndReplaceText(node);
        }
      });
    }
  };

  // Zoek zowel de main cart als mini-cart discount elementen
  const discountElements = document.querySelectorAll('.line-item__discount-list, .mini-cart__discount');
  discountElements.forEach(findAndReplaceText);
  
  // Extra controle voor specifieke mini-cart elementen
  const miniCartItems = document.querySelectorAll('.mini-cart__discount-list, .mini-cart__discount');
  miniCartItems.forEach(findAndReplaceText);
  
  // Observeer DOM-veranderingen voor dynamisch geladen elementen
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) { // Element node
            const discounts = node.querySelectorAll('.line-item__discount-list, .mini-cart__discount, .mini-cart__discount-list');
            discounts.forEach(findAndReplaceText);
          }
        });
      }
    });
  });
  
  // Start observatie op het hele document
  observer.observe(document.body, { childList: true, subtree: true });
});